// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__39gBy","containerItemsCenter":"Skeleton_containerItemsCenter__nDJdD"};